import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UmkreisFacettenService } from '../../../services/facetten/instance/umkreis-facetten.service';
import { LoaderService } from '../../../services/loader.service';
import { ScreenSizeService, ViewMode } from '../../../services/screen-size';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';
import { FacettenModalButtonComponent } from '../facetten-modal-button/facetten-modal-button.component';
import { OrtSuchumkreisComponent } from './ort-suchumkreis/ort-suchumkreis.component';

@Component({
  selector: 'now-wbsuche-lib-umkreis-facette',
  imports: [
    CommonModule,
    BasisFacetteComponent,
    OrtSuchumkreisComponent,
    FacettenModalButtonComponent
  ],
  templateUrl: './umkreis-facette.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmkreisFacetteComponent {
  facettenService = inject(UmkreisFacettenService);
  loaderService = inject(LoaderService);
  screenSizeService = inject(ScreenSizeService);

  @Input()
  postleitzahl?: string;
  public expanded$ = this.facettenService.expanded$;
  isDesktopOrBigger = toSignal(this.screenSizeService.rangeFrom$(ViewMode.DESKTOP));
}
